import { NavigationGuard, RouteRecordRaw } from 'vue-router'

const validateStopLossId: NavigationGuard = (to, from, next) => {
  const stopLossId = Number(to.params.id)
  if (isNaN(stopLossId) || stopLossId <= 0) {
    next({ name: 'NotFound' })
  } else {
    next()
  }
}

const stopLossConfigurationsRoute: RouteRecordRaw[] = [
  {
    path: 'StopLoss',
    name: 'stopLossConfigurations',
    component: () =>
      import('@/views/StopLossConfiguration/StopLossConfigurationsList.vue'),
    meta: {
      title: 'Stop Loss & Exclusions'
    },
    beforeEnter: async (to, from, next) => {
      next()
    }
  },
  {
    path: 'StopLoss/create',
    name: 'CreateStopLossConfiguration',
    component: () =>
      import('@/views/StopLossConfiguration/CreateStopLossConfiguration.vue'),
    meta: {
      title: 'Create Stop Loss'
    },
    beforeEnter: async (to, from, next) => {
      next()
    }
  },
  {
    path: 'StopLoss/:id/update',
    name: 'UpdateStopLossConfiguration',
    component: () =>
      import('@/views/StopLossConfiguration/CreateStopLossConfiguration.vue'),
    meta: {
      title: 'Update Stop Loss',
      bpSwitchFallback: 'stopLossConfigurations'
    },
    beforeEnter: validateStopLossId
  },
  {
    path: 'StopLoss/:id/preview',
    name: 'PreviewStopLossConfiguration',
    component: () =>
      import('@/views/StopLossConfiguration/StopLossPreviewPage.vue'),
    meta: {
      title: 'Stop Loss Preview',
      bpSwitchFallback: 'stopLossConfigurations'
    },
    beforeEnter: validateStopLossId
  },
  {
    path: 'StopLoss/:id/logs',
    name: 'StopLossPastRuns',
    component: () =>
      import('@/views/StopLossConfiguration/StopLossPastRuns.vue'),
    meta: {
      title: 'Stop Loss Execution Logs',
      bpSwitchFallback: 'stopLossConfigurations'
    },
    beforeEnter: validateStopLossId
  }
]

export default stopLossConfigurationsRoute
